import * as React from 'react';

import { useHydrateAtoms } from 'jotai/utils';
import { WritableAtom } from 'jotai/vanilla';

interface Props {
  initialValues: Iterable<
    readonly [WritableAtom<unknown, any[], any>, unknown]
  >;
  children: React.ReactNode;
}

export function HydrateAtoms({ initialValues, children }: Props) {
  useHydrateAtoms(initialValues);
  return <>{children}</>;
}
